import { ModalCard } from "./ModalCard";

export default ModalCard